<div
  class="pt-2"
  style="height: 100%; width: 100%; display: flex; flex-direction: column; overflow: hidden">
  <!-- Toolbar -->
  <div class="toolbar" [hidden]="showForm">
    <ca-llm-configuration-toolbar
      #toolbar
      (toggleForm)="openNewForm()"></ca-llm-configuration-toolbar>
  </div>

  <!-- List and Form -->
  <div class="content" style="flex: 1; display: flex; width: 100%">
    <!-- List -->
    <div class="list" style="width: 100%; padding: 10px" [hidden]="showForm">
      <ca-llm-configuration-list
        #list
        (showDetails)="onOpenDetails($event)"></ca-llm-configuration-list>
    </div>

    <!-- Form -->
    <div class="form" style="width: 100%" [hidden]="!showForm">
      <ca-llm-configuration-form
        (saved)="onFormSaved()"
        (closed)="onFormClosed()"
        (deleted)="onFormDeleted()"
        #form></ca-llm-configuration-form>
    </div>
  </div>
</div>
